import * as React from 'react';
import {
  InputContainer,
  Label,
  InputComponent,
  Star,
} from './input-components';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

type Props = {
  type?: string;
  label?: string;
  star?: string;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  onKeyUp?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  register?: any;
  min?: string;
  id?: string;
  noBottom?: boolean;
  backgroundColor?: string;
  showDefaultValue?: boolean;
  readOnly?: boolean;
};

export default function Input({
  type = 'text',
  label,
  disabled,
  placeholder,
  name,
  value,
  onChange,
  onKeyUp,
  onKeyDown,
  register,
  star,
  min,
  id,
  noBottom,
  backgroundColor,
  showDefaultValue,
  readOnly,
}: Props) {
  const props: any = {
    autoComplete: 'none',
    type: type,
    disabled: disabled,
    placeholder: placeholder,
    name: name,
    onChange: onChange,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    ref: register,
    min: min,
    id: id,
    backgroundColor: backgroundColor,
    readOnly: readOnly,
  };
  return (
    <InputContainer noBottom={noBottom}>
      {label && <Label>{label}</Label>}
      {star && <Star>{star}</Star>}
      {type === 'phone_number' ? (
        <ReactPhoneInput
          onlyCountries={['us']}
          country={'us'}
          disabled={disabled}
          placeholder="Enter phone number"
          value={value || ''}
          disableCountryCode={true}
          onChange={onChange ? onChange : () => console.log('')}
        />
      ) : showDefaultValue ? (
        <InputComponent {...props} defaultValue={value} />
      ) : (
        <InputComponent {...props} value={value} />
      )}
    </InputContainer>
  );
}
